module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gsRjv"))).then(() => module.bundle.root('2KbAe'));